export default function (router, store) {
  return async (to, from) => {
    router.app.$nextTick(() => {
      if (router.app.$loading) {
        router.app.$loading.finish()
      }
    })
  }
}
